import './index.scss'

import React from 'react'
import { Link } from 'react-router-dom'
import BEMHelper from 'react-bem-helper'

const bem = new BEMHelper('footer')

export default function Footer() {
  return (
    <nav {...bem('')}>
      <Link to="/personvern" {...bem('link')}>
        Personvern og informasjonskapsler
      </Link>
    </nav>
  )
}
